import type { components } from "../api/schema";

export type TestEnvironmentType = components["schemas"]["TestEnvironmentType"];

export const ENV_TYPE_LABEL: Record<TestEnvironmentType, string> = {
  manual: "Manual",
  automated: "Automated",
};
/** Lists of testing environments show Manual first (a person has to do those), then Automated. */
export const ENV_TYPE_ORDER: TestEnvironmentType[] = ["manual", "automated"];

export type EnvironmentGroup<T> = { type: TestEnvironmentType | "other"; label: string; items: T[] };

/** The environments grouped by type in ENV_TYPE_ORDER (a type with none is left out), each group
    keeping the order it came in (by number). Anything of another type (a stale cached entry with no
    type, a type added later) goes in a final "Other" group so it never disappears. The staff app
    and the portal share this. */
export function groupEnvironments<T extends { type?: TestEnvironmentType | null }>(
  environments: T[],
): EnvironmentGroup<T>[] {
  const groups: EnvironmentGroup<T>[] = ENV_TYPE_ORDER.map((type) => ({
    type,
    label: ENV_TYPE_LABEL[type],
    items: environments.filter((e) => e.type === type),
  }));
  groups.push({
    type: "other",
    label: "Other",
    items: environments.filter((e) => !e.type || !ENV_TYPE_ORDER.includes(e.type)),
  });
  return groups.filter((g) => g.items.length > 0);
}
